import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const customerId = params.customerId;
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };
    delete options.params.customerId;

    return axios.get(`${url}/customers/${customerId}/locations`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/locations/${id}`, options)
        .then(response => {
            let location = jsona.deserialize(response.data);
            delete location.links;
            return location;
        });
}

function add(location) {
    const payload = jsona.serialize({
        stuff: location,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/locations`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(location) {
    const payload = jsona.serialize({
        stuff: location,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/locations/${location.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/locations/${id}`, options);
}

export default {
    list,
    get,
    add,
    update,
    destroy
};